export class orgInfoFlags {
    btnSave = false;
    btnReset = false;
    btnBack = false;
    btnAdd = true;
    btnResetTbl = true;
    btnAddDisabled = false;
    btnSaveDisabled = false;
    toolTip = 'Save';
    showFlag = true;
    isEdit = false;
}
